import { render, staticRenderFns } from "./SportelloFabbricatiIdStanzeIdView.vue?vue&type=template&id=7f64e4e3&"
import script from "./SportelloFabbricatiIdStanzeIdView.vue?vue&type=script&lang=ts&"
export * from "./SportelloFabbricatiIdStanzeIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports